const accountSettings = {
    title: 'Ustawienia konta',
    personalDataTab: {
        title: 'Dane osobowe',
        inputs: {
            name: 'Imię',
            surname: 'Nazwisko',
            companyName: 'Nazwa firmy',
            nip: 'NIP'
        }
    },
    passwordsTab: {
        title: 'Hasła',
        inputs: {
            oldPassword: 'Aktualne hasło',
            newPassword: 'Nowe hasło',
            confirmNewPassword: 'Potwierdź nowe hasło'
        },
        errors: {
            newPasswordNotRepeatedCorrectly: 'Podane hasło i potwierdzenie hasła różnią się'
        }
    },
    emailTab: {
        title: 'E-mail',
        inputs: {
            email: 'Adres e-mail'
        },
        submitSucceeded: 'Mail potwierdzający zmianę został wysałny na Twój aktualny adres email. Zaloguj się, aby potwierdzić zmianę. Jeśli nie otrzymasz maila w przeciągu 2h - prosimy skontaktuj się z Administratorem.'
    },
    changeEmailConfirm: {
        pending: {
            title: 'Potwierdzanie zmiany adresu email',
            description: 'Trwa potwierdzanie zmiany adresu email. Proszę czekać...',
        },
        success: {
            title: 'Adres email został zmieniony',
            description: 'Zmiana adresu email została potwierdzona.',
        },
        error: {
            title: 'Nie udało się potwierdzić zmiany',
            description: 'Token jest nieprawidłowy, wygasł albo wystąpił błąd serwera.',
        },
        missingToken: {
            title: 'Nieprawidłowy link',
            description: 'W linku brakuje tokenu potwierdzającego zmianę adresu email.',
        },
        backToAccountSettings: 'Wróć do ustawień konta',
    }
};

export default accountSettings;